"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupWithDeleteButtonRenderer = GroupWithDeleteButtonRenderer;
const React = __importStar(require("react"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const GenesysPropertiesSelectorTypes = __importStar(require("../genesys-properties-selector-types"));
const PropertiesSelectorElements = __importStar(require("./elements"));
const Elements = __importStar(require("../elements"));
const LocalElements = __importStar(require("./elements"));
const Contexts = __importStar(require("../contexts"));
const row_renderer_1 = require("./row-renderer");
function GroupWithDeleteButtonRenderer({ activatedQuantitySelectors, conversionParametersMap, fieldGroup, filterPrettyPrint, hidePropertyNames, onDelete, onQuantityChange, renderGroup, selectorInfoMap, uniqueId, valueSourcesDict, translatePropertyValue, showDelete }) {
    return (React.createElement(Contexts.TranslateContext.Consumer, { key: `${uniqueId}-${renderGroup.key}` }, translate => (React.createElement(PropertiesSelectorElements.PropertySelectorGroup, null,
        renderGroup.key !== GenesysPropertiesSelectorTypes.NO_GROUP && (React.createElement(Elements.ExpanderWithArrow, { onToggle: renderGroup.onToggle, isCollapsed: renderGroup.isCollapsed, text: renderGroup.translatedName })),
        React.createElement(PropertiesSelectorElements.PropertySelectorGroupRows, { hidden: renderGroup.isCollapsed },
            React.createElement(PropertiesSelectorElements.StyledPropertySelectorGroupTable, null,
                React.createElement("tbody", null,
                    renderGroup.properties.map(renderProperty => {
                        const selectorInfo = selectorInfoMap[renderProperty.propertyName];
                        return (React.createElement(row_renderer_1.ProductPropertyRowRenderer, { fieldName: renderProperty.fieldName, key: `${renderGroup.key}-${renderProperty.propertyName}`, fieldGroup: fieldGroup, hidePropertyName: hidePropertyNames, selectorInfo: selectorInfo, valueSourcesDict: valueSourcesDict, conversionParameters: conversionParametersMap[renderProperty.propertyName], isQuantitySelectorActive: !!activatedQuantitySelectors[renderProperty.propertyName], onQuantityChange: quantity => onQuantityChange(renderProperty.propertyName, quantity), translatePropertyValue: translatePropertyValue, filterPrettyPrint: filterPrettyPrint }));
                    }),
                    React.createElement("tr", null,
                        !hidePropertyNames && (React.createElement(React.Fragment, null,
                            React.createElement("td", null),
                            React.createElement("td", null))),
                        React.createElement("td", null,
                            React.createElement(LocalElements.DeleteButtonContainer, null, showDelete && (React.createElement(Elements.DeleteButton, { text: translate(LanguageTexts.deleteText()), onClick: onDelete })))),
                        React.createElement("td", null)))))))));
}
//# sourceMappingURL=group-with-delete-button-renderer.js.map